import { MultiTab } from '@components/multiTab';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupsListPage } from './Groups';
import { MetersListPage } from './Meters';
import AssetsListPage from './Assets/AssetsListPage';
import { TagsListPage } from './Tags';

const AssetsPage: FC = () => {
  const { t } = useTranslation();
  const tabs = [
    {
      title: t('common.buildings'),
      component: <AssetsListPage />,
    },
    {
      title: t('common.meters'),
      component: <MetersListPage />,
    },
    {
      title: t('common.groups'),
      component: <GroupsListPage />,
    },
    {
      title: t('common.tags'),
      component: <TagsListPage />,
    },
  ];

  return (
    <div>
      <MultiTab tabs={tabs} />
    </div>
  );
};
export default AssetsPage;
